import axios from 'axios';
import { API_URL } from '../config';

export async function searchRecipients(q) {
  const res = await axios.get(`${API_URL}/mailing/search`, {
    params: { q: q || '' },
    withCredentials: true,
  });
  return res.data;
}

export async function upsertRecipient(email) {
  const res = await axios.patch(
    `${API_URL}/mailing/upsert`,
    { email },
    { withCredentials: true },
  );
  return res.data;
}

export async function setRecipientActive(id, isActive) {
  const res = await axios.patch(
    `${API_URL}/mailing/active`,
    { id, isActive },
    { withCredentials: true },
  );
  return res.data;
}

export async function deleteRecipientCascade(id) {
  const res = await axios.delete(`${API_URL}/mailing/${id}`, {
    withCredentials: true,
  });
  return res.data;
}

// ===== GROUPS =====
export async function listGroups(params = {}) {
  const res = await axios.get(`${API_URL}/mailing`, {
    params,
    withCredentials: true,
  });
  return res.data;
}

export async function createGroup(payload) {
  const res = await axios.patch(`${API_URL}/mailing/groupsCreate`, payload, {
    withCredentials: true,
  });
  return res.data;
}

export async function updateGroup(payload) {
  const res = await axios.patch(`${API_URL}/mailing/update`, payload, {
    withCredentials: true,
  });
  return res.data;
}

export async function deleteGroup(id) {
  const res = await axios.delete(`${API_URL}/mailing/remove/${id}`, {
    withCredentials: true,
  });
  return res.data;
}

// ===== GROUP DETAILS: MEMBERS =====
export async function getGroupMembers(groupId) {
  const res = await axios.get(`${API_URL}/mailing/groups/${groupId}/members`, {
    withCredentials: true,
  });
  return res.data; // group + members[ { recipient } ]
}

export async function setGroupMembers(groupId, emails) {
  const res = await axios.put(
    `${API_URL}/mailing/groups/${groupId}/members`,
    { emails },
    { withCredentials: true },
  );
  return res.data;
}

// ===== INCLUDES =====
export async function getGroupIncludes(groupId) {
  const res = await axios.get(`${API_URL}/mailing/groups/${groupId}/includes`, {
    withCredentials: true,
  });
  return res.data; // group + includes + includedBy
}

export async function addGroupInclude(parentGroupId, childGroupId) {
  const res = await axios.post(
    `${API_URL}/mailing/groups/${parentGroupId}/includes`,
    { childGroupId },
    { withCredentials: true },
  );
  return res.data;
}

export async function removeGroupInclude(parentGroupId, childGroupId) {
  const res = await axios.delete(
    `${API_URL}/mailing/groups/${parentGroupId}/includes/${childGroupId}`,
    { withCredentials: true },
  );
  return res.data;
}

// ===== RESOLVE =====
export async function resolveGroupEmails(groupId, onlyActive = true) {
  const res = await axios.get(`${API_URL}/mailing/resolve`, {
    params: { groupId, onlyActive },
    withCredentials: true,
  });
  return res.data; // { emails: [], count, ... }
}
